import { render, staticRenderFns } from "./PListTree.vue?vue&type=template&id=61437c88&scoped=true"
import script from "./PListTree.vue?vue&type=script&lang=js"
export * from "./PListTree.vue?vue&type=script&lang=js"
import style0 from "./PListTree.vue?vue&type=style&index=0&id=61437c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61437c88",
  null
  
)

export default component.exports